<template>
  <div class="user-manager">
    <div class="user-manager__header">
      <s-search-input
        class="user-manager__search-input-group"
        v-model="searchTerm"
        :placeholder="$t('user-manager.query.search-placeholder')"
        :disabled="existModalOpen"
      />
      <div>
      <b-button
        variant="primary"
        @click="newUser()"
      >
        {{ $t('user-manager.query.new-user') }}
      </b-button>
    </div>
    </div>
    <user-grid @modals-open="modalsOpen" :search-term="searchTerm" />
  </div>
</template>

<script>
import UserGrid from '@/domain/components/generalPanel/adminPanel/user/List';
import GlobalUserService from '@/services/user';

export default {
  components: {
    UserGrid,
  },
  created() {
    GlobalUserService.validateUserPermission('PER011');
  },
  data() {
    return {
      searchTerm: null,
      existModalOpen: false,
    };
  },
  methods: {
    newUser() {
      this.$router.push({
        name: 'user.new',
      });
    },
    modalsOpen(state) {
      this.existModalOpen = state;
    },
  },
};
</script>

<style lang="sass" scoped>
@import src/styles/defaults/variables
@import "src/styles/defaults/mobile-first"

.user-manager
  &__header
    display: flex
    flex-direction: column
    padding: 10px
    button
      margin-top: 1em
  +media-min-sm()
    &__search-input-group
      width: 350px
    &__header
      flex-direction: row
      justify-content: space-between
      button
        margin-top: 0
        margin-left: 1em
  +media-min-md()
  +media-min-lg()
</style>
